export default __webpack_public_path__ + "static/media/genetics.ba836db1.png";